// extracted by mini-css-extract-plugin
module.exports = {"container":"CouponDetailLegal_container__8IO4k"};